import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoordinateCellLocalStoreService } from './coordinate-cell-local-store.service';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-coordinate-cell',
    templateUrl: './coordinate-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CoordinateCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, NgxSkeletonLoaderModule]
})
export class CoordinateCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;
  constructor(protected localStore: CoordinateCellLocalStoreService) {
    super(localStore);
  }

}
